"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
function isUpdaterFunction(updater) {
  return typeof updater === "function";
}
exports.isUpdaterFunction = isUpdaterFunction;
//# sourceMappingURL=types.cjs.map
